import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { InputField } from '../Common/inputField';
import Spinner from '../../components/Widgets/spinner';

class PackerForm extends Component {
  componentDidMount() {
    this.props.resetCreatePacker();
    this.props.resetEditPacker();
  }

  handleFormSubmit(formProps) {
    if (this.props.currentPacker) {
      this.props.editPacker(formProps);
    } else {
      this.props.createPacker(formProps);
    }
  }

  render() {
    const { handleSubmit, closePT, submitting, pristine, valid } = this.props;
    return (
      <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))} >
        <br />
        <Row>
          <Col xs={12}>
            <div className="form-group">
              <label><Translate value="name" /><span className="asteriksReq">*</span></label>
              <Field name="name" component={InputField}/>
            </div>
          </Col>
        </Row>
        <button
          action="submit"
          className="btn btn-success buttonStyle"
          disabled={submitting || pristine}
          style={{ marginTop: '25px' }}
        >
          <em className="fa fa-save" /><Translate value="save" />
        </button>
        { this.props.isCreating || this.props.isEditing && <Spinner/> }
        { this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> }
        { this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> }
      </form>
    );
  }
}

export default PackerForm;



// WEBPACK FOOTER //
// ./master/jsx/components/General/packerForm.jsx